import React from 'react';
import { Body, Box } from '@edreamsodigeo/prisma-design-system';

import { BaggageConditionText } from '@/components/FlightSummary/BaggageCondition/BaggageConditionText';
import type { BaggageConditionTextProps } from '@/components/FlightSummary/BaggageCondition/types';

export const BaggageConditionTextStyled: React.FC<
  BaggageConditionTextProps
> = ({ baggageCondition, hasCabinBag }) => (
  <Box data-testid="textBaggage">
    <Body type="small" color="neutral.80">
      <BaggageConditionText
        baggageCondition={baggageCondition}
        hasCabinBag={hasCabinBag}
      />
    </Body>
  </Box>
);
